import cx from 'classnames';

import type { Enquiry } from '@motorway/motorway-handshake-components/types';

import styles from './NumericGradingText.module.scss';

const grades = {
  'all': 'All',
  'grade': 'Grade',
  '1': 'Grade 1',
  '2': 'Grade 2',
  '3': 'Grade 3',
  '4': 'Grade 4',
  '5': 'Grade 5',
  'grade-1': '1',
  'grade-2': '2',
  'grade-3': '3',
  'grade-4': '4',
  'grade-5': '5',
};

export const NumericGradingText: React.FC<{
  grade: Enquiry['enquiry']['vehicleDetails']['numericGrade'];
  size: 'regular' | 'large';
}> = ({ grade, size }) => {
  return (
    <div
      className={cx(styles.container, size === 'large' && styles.large)}
    >
      {grade
        ? (
            <>
              <span>{grades.grade}</span>
              <div
                className={cx([
                  styles.numericGradeNumberContainer,
                  styles[`grade-${grade}`],
                  size === 'large' && styles.large,
                ])}
              >
                <span>{grades[`grade-${grade}`]}</span>
              </div>
            </>
          )
        : (
            <span>-</span>
          )}
    </div>
  );
};
